function getCustomer(email, pagetype){
    var myHeaders = new Headers();
    myHeaders.append("User-Agent", "Shopify");
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Access-Control-Allow-Origin", "*");

    fetch("/apps/rt/api/customer/", 
    {
        method: "POST",
        headers: myHeaders,
        body: '{"email": "' + email + '"}',
        redirect: "follow"
    })
    .then((response) => {
        if (!response.ok) {
            throw new Error("Network response was not ok");
        } else {
            return response.json();
        }
    })
    .then((result) => {
        console.log(result);

        if(result) {
            if (pagetype === "view") {
                document.querySelector('.customer_first_name').textContent = result.FirstName;
                document.querySelector('.customer_last_name').textContent = result.LastName;
                document.querySelector('.customer_email_Address').textContent = result.Email;
                if (document.querySelector('.customer_phone_number')) {
                    document.querySelector('.customer_phone_number').textContent = result.Mobile;
                }
                if (document.querySelector('.customer_birthday')) {
                    document.querySelector('.customer_birthday').textContent = result.BirthDate;
                }
                document.querySelector('.customer_sms_marketing_state').textContent = result.marketingStateOfSMS ? result.marketingStateOfSMS : "NOT_SUBSCRIBED";
                document.querySelector('.customer_email_marketing_state').textContent = result.marketingStateOfEmail;

                // get cart cookie
                const cartCookie = getCookie("cart");
                const expireddate = new Date();
                expireddate.setMonth(expireddate.getMonth() + 1);

                if (cartCookie !== undefined) { 
                    if (result.shopifyCartId && result.shopifyCartId !== "") {
                        if (decodeURIComponent(result.shopifyCartId.replace('gid://shopify/Cart/', '')) !== decodeURIComponent(cartCookie.replace('gid://shopify/Cart/', ''))) {
                            // if cart cookie is not same as shopifyCartId, merge cart
                            fetch("/apps/rt/api/basket/mergebasket/", 
                            {
                                method: "POST",
                                headers: myHeaders,
                                body: JSON.stringify({
                                    "cartId": 'gid://shopify/Cart/' + result.shopifyCartId.replace('gid://shopify/Cart/', ''),
                                    "cartIdToBeMigrated": 'gid://shopify/Cart/' + decodeURIComponent(cartCookie.replace('gid://shopify/Cart/', ''))
                                }),
                            })
                            .then((response) => {
                                if (!response.ok) {
                                    throw new Error("Network response was not ok");
                                }
                                return response.json();
                            })
                            .then((mergeresult) => {
                                if (mergeresult.code !== "99") {
                                    fetch("/apps/rt/api/basket/updateBasketIdToCustomer", 
                                    {
                                        method: "POST",
                                        headers: myHeaders,
                                        body: JSON.stringify({
                                            "email": email,
                                            "cartId": mergeresult.id,
                                        }),
                                        redirect: "follow"
                                    })
                                    .then((response) => {
                                        if (!response.ok) {
                                            throw new Error("Network response was not ok");
                                        }
                                        return response.json();
                                    })
                                    .then((updateresult) => {
                                        // create cart cookie when logged in
                                        document.cookie = 'cart=' + encodeURIComponent(mergeresult.id.replace('gid://shopify/Cart/', ''))
                                                        + '; expires=' + expireddate.toUTCString()
                                                        + '; path=/;';
                                        location.reload();
                                    } )
                                    .catch((error) => console.error(error));
                                }
                            } )
                            .catch((error) => console.error(error));
                        }
                    } else {
                        fetch("/apps/rt/api/basket/updateBasketIdToCustomer", 
                        {
                            method: "POST",
                            headers: myHeaders,
                            body: JSON.stringify({
                                "email": email,
                                "cartId": 'gid://shopify/Cart/' + cartCookie,
                            }),
                            redirect: "follow"
                        })
                        .then((response) => {
                            if (!response.ok) {
                                throw new Error("Network response was not ok");
                            }
                            return response.json();
                        })
                        .then((updateresult) => {
                            
                        } )
                        .catch((error) => console.error(error));
                    }
                } else {
                    const expireddate = new Date();
                    expireddate.setMonth(expireddate.getMonth() + 1);
                    if (result.shopifyCartId !== "") {
                        // create cart cookie when logged in
                        document.cookie = 'cart=' + encodeURIComponent(result.shopifyCartId.replace('gid://shopify/Cart/', ''))
                                        + '; expires=' + expireddate.toUTCString()
                                        + '; path=/;';
                        location.reload();
                    } else {
                        // create cart id then set cookie
                        fetch("/apps/f21/api/basket/createbasketid", 
                        {
                            method: "POST",
                            headers: myHeaders,
                            body: JSON.stringify({
                                "email": email
                            }),
                            redirect: "follow"
                        })
                        .then((response) => {
                            if (!response.ok) {
                                throw new Error("Network response was not ok");
                            }
                            return response.json();
                        })
                        .then((cartinfo) => {
                            fetch("/apps/f21/api/basket/updateBasketIdToCustomer", 
                            {
                                method: "POST",
                                headers: myHeaders,
                                body: JSON.stringify({
                                    "email": email,
                                    "cartId": cartinfo.shopifyCartId,
                                }),
                                redirect: "follow"
                            })
                            .then((response) => {
                                if (!response.ok) {
                                    throw new Error("Network response was not ok");
                                }
                                return response.json();
                            })
                            .then((updateresult) => {
                                // overwrite cart cookie
                                document.cookie = 'cart=' + encodeURIComponent(cartinfo.shopifyCartId.replace('gid://shopify/Cart/', ''))
                                                + '; expires=' + expireddate.toUTCString()
                                                + '; path=/;';
                                location.reload();
                            } )
                            .catch((error) => console.error(error));
                        } )
                        .catch((error) => console.error(error));
                    }
                }

                
            } else if (pagetype === "edit") {
                document.getElementById('customer_firstname').value = result.FirstName;
                document.getElementById('customer_lastname').value = result.LastName;
                document.getElementById('customer_phone').value = result.Mobile;
                document.getElementById('customer_birthdate').value = result.BirthDate;
                if (result.marketingStateOfEmail === "SUBSCRIBED") {
                    document.getElementById('email_marketing_consent').checked = true; 
                }
                if (result.marketingStateOfSMS === "SUBSCRIBED") {
                    document.getElementById('sms_marketing_consent').checked = true; 
                }
                //document.querySelector('.customer_sms_marketing_state').textContent = result.marketingStateOfSMS;
            }
            
        }

    })
    .catch((error) => console.error(error));
}

async function updateCustomer(email) {
    myHeaders = new Headers();
    myHeaders.append("User-Agent", "Shopify");
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Access-Control-Allow-Origin", "*");

    fetch("/apps/rt/api/customer/update", 
    {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify({
            "email": email,
            "firstName": document.getElementById('customer_firstname').value,
            "lastName": document.getElementById('customer_lastname').value,
            "PhoneNumber": document.getElementById('customer_phone').value,
            "birthDate": document.getElementById('customer_birthdate').value,
            "emailMarketingConsent": {
                    "marketingState": document.getElementById('email_marketing_consent').checked ? "SUBSCRIBED" : "UNSUBSCRIBED",
            },
            "smsMarketingConsent": {
                    "marketingState": document.getElementById('sms_marketing_consent').checked ? "SUBSCRIBED" : "UNSUBSCRIBED",
            }
        }),
        redirect: "follow"
    })
    .then((response) => {
        if (!response.ok) {
            throw new Error("Network response was not ok");
        }
        return response.json();
    })
    .then((result) => {
        if(result.code === "00") {
            //console.log(result);
            window.location.href = "/account";
        } else if (result.code === "92") {
            document.querySelector('.banner--error').classList.remove('hidden');
            document.querySelector('.banner--error').textContent = result.errorMessage;
            console.error("Error: " + result.errorMessage);
        }
    } )
    .catch((error) => console.error(error));
}

function cancelOrder(orderId, email) {
    myHeaders = new Headers();
    myHeaders.append("User-Agent", "Shopify");
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Access-Control-Allow-Origin", "*");

    fetch("/apps/rt/api/basket/cancelOrder", 
    {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify({
            "email": email,
            "orderId": "gid://shopify/Order/" + orderId,
            "notifyCustomer": true,
            "reason": ""
        }),
        redirect: "follow"
    })
    .then((response) => {
        if (!response.ok) {
            throw new Error("Network response was not ok");
        }
        return response.json();
    })
    .then((result) => {
        if(result.code === "00") {
            window.location.href = "/pages/order-history";
        } else {
            document.querySelector('.banner--error').classList.remove('hidden');
            document.querySelector('.banner--error').textContent = result.errorMessage;
            console.error("Error: " + result.errorMessage);
        }
    } )
    .catch((error) => console.error(error));
}


function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
        return parts.pop().split(';').shift();
    }
}